<div class="files-box"
    cdkDropListGroup
    [class.files-box--compact]="compactMode"
    [class.files-box--list]="!previewBlocksEnabled">

    <div class="files-box__breadcrumbs">
        <div class="files-box__breadcrumbs__arrow-container arrow-back">
            <nb-icon icon="arrow-left-outline"
                class="cursor-pointer"
                (click)="scrollBreadcrumbs(-200)"
                *ngIf="bc.scrollLeft > 0"></nb-icon>
        </div>
        
        <div class="files-box__breadcrumbs__container" (scroll)="onBreadcrumbScroll()" #bc>
            <div class="breadcrumbs__breadcrumb" [class.cursor-pointer]="!last"
                cdkDropList cdkDropListSortingDisabled [cdkDropListConnectedTo]="folderLists"
                (cdkDropListDropped)="onFileDrop($event, breadcrumb.id)"
                *ngFor="let breadcrumb of breadcrumbs; let last = last;">
                <div
                    (click)="!last && goBackPage(breadcrumb.id)"
                    [class.breadcrumb--active]="last">
                    {{breadcrumb.name}}
                </div>
                <div class="breadcrumb__break" *ngIf="!last">
                    |
                </div>
            </div>
        </div>

        <div class="files-box__breadcrumbs__arrow-container arrow-forward">
            <nb-icon icon="arrow-right-outline"
                class="cursor-pointer"
                (click)="scrollBreadcrumbs(200)"
                *ngIf="bc.scrollLeft + bc.clientWidth < bc.scrollWidth - 100"></nb-icon>
        </div>
    </div>
    
    <div class="files-box__container" (scroll)="onScroll($event)">
        <div class="files-box__actions" *ngIf="!previewBlocksEnabled && !isLoading && files.length">
            <nb-checkbox *ngIf="multiSelect" 
                [indeterminate]="selectedFiles.length > 0 && selectedFiles.length !== files.length"
                [checked]="selectedFiles.length > 0 && selectedFiles.length === files.length"
                (checkedChange)="changeSelection($event)"></nb-checkbox>

            <div class="files-box__actions__columns"
                [class.files-box__actions__columns--print-list]="displayType === displayTypes.LIST_PRINT"
                *ngIf="!selectedFiles.length">
                <div class="cursor-pointer" [class.padding-left]="!multiSelect" (click)="changeSort(sortFields.NAME)">
                    {{ 'common.name' | translate }}
                    <nb-icon [hidden]="sort.field !== sortFields.NAME" [icon]="icon"></nb-icon>
                </div>
                <div class="cursor-pointer hide-responsive"
                    *ngIf="displayType === displayTypes.LIST"
                    (click)="changeSort(sortFields.SIZE)">
                    {{ 'device.files.size' | translate }}
                    <nb-icon [hidden]="sort.field !== sortFields.SIZE" [icon]="icon"></nb-icon>
                </div>
                <div class="cursor-pointer"
                    *ngIf="displayType !== displayTypes.LIST_PREVIEW"
                    (click)="changeSort(sortFields.CREATED_AT)">
                    {{ 'common.created-at' | translate }}
                    <nb-icon [hidden]="sort.field !== sortFields.CREATED_AT" [icon]="icon"></nb-icon>
                </div>
            </div>
                
            <ng-container *ngIf="selectedFiles.length">
                <div class="files-box__actions__checkbox-group">                
                    <span>
                        {{ selectedFiles.length }}
                        {{ filesTranslation | translate | lowercase }}
                    </span>
    
                    <span class="files-box__actions__more"
                        *ngIf="actions?.length"
                        nbContextMenuTrigger="click"
                        [nbContextMenuTag]="menuName"
                        [nbContextMenu]="actions">
                        <nb-icon icon="more-horizontal-outline"></nb-icon>
                        {{ 'common.actions' | translate }}
                    </span>
                </div>
    
                <div class="files-box__actions__details">
                    <div>{{ selectedSize | fileSize }}</div>
                </div>
            </ng-container>
        </div>

        <div class="files-box__files" [nbSpinner]="isLoading" nbSpinnerSize="large">
            <div class="files-box__files__folders"
                cdkDropList cdkDropListSortingDisabled [cdkDropListConnectedTo]="folderLists"
                *ngIf="files | catalogFilter: true as files">
                <div class="files__title" *ngIf="files.length !== 0 && previewBlocksEnabled">Catalogs:</div>
                <ng-container *ngFor="let file of files; trackBy: trackByFn">
                    <app-file-browser-file
                        cdkDropList
                        [cdkDragDisabled]="!enableDrag"
                        cdkDrag cdkDragPreviewContainer="parent"
                        [disabled]="!!file.loading"
                        [class.list]="!previewBlocksEnabled"
                        [id]="file.id" 
                        [file]="file"
                        [cdkDragData]="file"
                        [cdkDragStartDelay]="dragDelay"
                        [class.compact]="compactMode"
                        [displayType]="displayType"
                        [enableShare]="enableShare"
                        [enableDelete]="enableDelete"
                        [multiSelect]="multiSelect"
                        [selected]="selectedFiles.includes(file)"
                        (selectedChange)="changeFileSelection($event, file)"
                        (cdkDropListDropped)="onFileDrop($event, file)"
                        (onNext)="goNextPage($event)"
                        (onShare)="onShare.next($event)"
                        (onDelete)="onDelete.next($event)">

                        <div *cdkDragPreview>
                            <nb-icon icon="folder-outline"></nb-icon>
                            {{ file.name }}
                        </div>

                    </app-file-browser-file>
                </ng-container>
            </div>

            <div cdkDropList cdkDropListSortingDisabled [cdkDropListConnectedTo]="folderLists"
                class="files-box__files__regular" *ngIf="files | catalogFilter: false as files">
                <div class="files__title" *ngIf="files.length !== 0 && previewBlocksEnabled">Files:</div>
                <ng-container *ngFor="let file of files; trackBy: trackByFn">
                    <app-file-browser-file 
                        [cdkDragDisabled]="!enableDrag"
                        cdkDrag cdkDragPreviewContainer="parent"
                        [disabled]="!!file.loading"
                        [class.list]="!previewBlocksEnabled"
                        [file]="file"
                        [cdkDragData]="file"
                        [cdkDragStartDelay]="dragDelay"
                        [displayType]="displayType"
                        [class.compact]="compactMode"
                        [enableUnlock]="enableUnlock"
                        [enableShare]="enableShare"
                        [enablePrint]="enablePrint"
                        [enableDelete]="enableDelete"
                        [enableDownload]="enableDownload"
                        [previewTemplate]="previewTemplate"
                        [infoTemplate]="infoTemplate"
                        [multiSelect]="multiSelect"
                        [selected]="selectedFiles.includes(file)"
                        (selectedChange)="changeFileSelection($event, file)"
                        (onShare)="onShare.next($event)"
                        (onUnlock)="onUnlock.next($event)"
                        (onDelete)="onDelete.next($event)"
                        (onPrint)="onPrint.next($event)"
                        (onDownload)="onDownload.next($event)">
                        
                        <div *cdkDragPreview>
                            <nb-icon icon="file-outline"></nb-icon>
                            {{ file.name }}
                        </div>

                    </app-file-browser-file>
                </ng-container>
            </div>
            
            <ng-container *ngIf="!files?.length">
                <div class="files-box__files--empty">
                    {{'device.files.empty-catalog' | translate}}
                </div>
            </ng-container>
        </div>
    </div>
</div>
